import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const STEPS = [
  { label: 'Rol invullen', short: 'Rol' },
  { label: 'Experts ontdekken', short: 'Experts' },
  { label: 'GPT-profiel', short: 'Profiel' },
  { label: 'Bronnen verdiepen', short: 'Bronnen' },
  { label: 'GPT bouwen', short: 'Bouwen' },
];

export default function StepIndicator({ currentStep }) {
  return (
    <div className="gpt-steps">
      {STEPS.map((step, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;
        const cls = `gpt-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`;

        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <div className={`gpt-step-connector ${isCompleted ? 'completed' : ''}`} />
            )}
            <div className={cls}>
              <span className="gpt-step-number">
                {isCompleted ? <CheckRoundedIcon sx={{ fontSize: 14 }} /> : stepNum}
              </span>
              <span>{step.label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
